import React from "react";
import { Box, Typography } from "@mui/material";
import { formatCurrencyManual } from "../../utils/formatters";
import { FormCard } from "../../components/ui/form";
import { Num } from "../../components/ui";
import { tokens } from "../../theme";

/** Dato del cliente: etiqueta chica arriba, valor abajo. Apila solo en teléfono. */
const ClientFact = ({ label, children, numeric, color }) => (
  <Box sx={{ display: "flex", flexDirection: "column", gap: "2px", minWidth: 0 }}>
    <Typography sx={{ fontSize: "11.5px", fontWeight: 500, color: tokens.ink3 }}>
      {label}
    </Typography>
    {numeric ? (
      <Num sx={{ fontSize: "14px", fontWeight: 600, color }}>{children}</Num>
    ) : (
      <Typography
        sx={{ fontSize: "14px", fontWeight: 600, overflow: "hidden", textOverflow: "ellipsis" }}
      >
        {children}
      </Typography>
    )}
  </Box>
);

const HeadClientAccount = ({ client, totalFacturas, totalPagos }) => {
  // Nuevo enfoque: SALDO ACTUAL = Facturas autorizadas - Saldo a favor del cliente
  const saldoAFavor = Number(client.balance || 0);
  const saldoActual = totalFacturas - saldoAFavor;

  // Invertir el signo para mostrar correctamente la deuda
  const saldoMostrado = -saldoActual;

  return (
    <FormCard title="Estado de cuenta" sx={{ width: "100%", minWidth: 0 }}>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "minmax(0, 1fr)", sm: "repeat(auto-fit, minmax(190px, 1fr))" },
          gap: { xs: "12px", md: "16px" },
        }}
      >
        <ClientFact label="Cliente">{client ? client.company : "No disponible"}</ClientFact>
        <ClientFact label="CUIT" numeric>
          {client ? client.cuit : "No disponible"}
        </ClientFact>
        <ClientFact
          label={saldoMostrado < 0 ? "Saldo actual (debe)" : "Saldo actual"}
          numeric
          color={saldoMostrado < 0 ? "var(--sup-state-danger-ink)" : undefined}
        >
          {formatCurrencyManual(saldoMostrado)}
        </ClientFact>
      </Box>
    </FormCard>
  );
};

export default HeadClientAccount;
